import { textCss } from '../../../common/Css';
import React from 'react';

export const NotFound = () => {
    return (
        <div
            className='mx-3 my-2  h-10 items-center flex px-6 rounded-md gap-6'
            style={{ border: '1px solid rgb(178,95,94)', color: 'rgb(145,45,56)' }}
        >
            <p className={textCss?.inputText} style={{ color: 'rgb(145,45,56)' }}>
                User Details Not Found
            </p>
        </div>
    );
};
